import { useState, useEffect, useRef, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ReactComponent as ArrowRightIcon } from '../assets/svg/keyboardArrowRightIcon.svg'
import visibilityIcon from '../assets/svg/visibilityIcon.svg'
import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  updateProfile,
} from 'firebase/auth'
import { db } from '../firebase.config'
import { getDoc, setDoc, doc, serverTimestamp } from 'firebase/firestore'
import OAuth from '../components/OAuth'
import { toast } from 'react-toastify'
import RoleContext from '../context/roleContext'

function AddAgent() {
  const [showPassword, setShowPassword] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    password: '',
  })

  const { name, email, password } = formData

  const navigate = useNavigate()
  const isMounted = useRef(true)
  const auth = getAuth()

  const { role } = useContext(RoleContext)

  useEffect(() => {
    const fetchUserRole = async () => {
      // const docRef = doc(db, 'users', auth.currentUser.uid)
      // const docSnap = await getDoc(docRef)
      // // docRef.id

      if (role !== 'super-admin') {
        toast.error('Only super-admins can add agents!')
        navigate('/profile')
      }
    }
    if (isMounted) {
      onAuthStateChanged(auth, (user) => {
        if (user) {
          fetchUserRole()
        } else {
          navigate('/sign-in')
        }
        return () => {
          isMounted.current = false
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted])

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }))
  }

  const onSubmit = async (e) => {
    e.preventDefault()

    try {
      const auth = getAuth()
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      )

      const user = userCredential.user

      updateProfile(auth.currentUser, {
        displayName: name,
      })

      const formDataCopy = { ...formData }
      delete formDataCopy.password
      formDataCopy.timestamp = serverTimestamp()

      await setDoc(doc(db, 'users', user.uid), formDataCopy)

      navigate('/')
    } catch (error) {
      console.log('Something went wrong with registration')
    }
  }
  return (
    <>
      <div className="pageContainer">
        <header>
          <p className="pageHeader">Add User</p>
        </header>
        <form onSubmit={onSubmit}>
          <input
            type="text"
            className="nameInput"
            placeholder="Name"
            id="name"
            value={name}
            onChange={onChange}
          />
          <input
            type="email"
            className="emailInput"
            placeholder="Email"
            id="email"
            value={email}
            onChange={onChange}
          />
          <select id="role" className="emailInput" onChange={onChange}>
            <option value={null}>Select role</option>
            <option value="admin">Admin</option>
            <option value="super-admin">Super Admin</option>
          </select>
          <div className="passwordInputDiv">
            <input
              type={showPassword ? 'text' : 'password'}
              className="passwordInput"
              placeholder="Password"
              id="password"
              value={password}
              onChange={onChange}
            />
            <img
              src={visibilityIcon}
              alt="show password"
              className="showPassword"
              onClick={() => setShowPassword((prevState) => !prevState)}
            />
          </div>
          <Link to="/forgot-password" className="forgotPasswordLink">
            Forgot Password
          </Link>

          <div className="signUpBar">
            <p className="signUpText">Add Admin</p>
            <button className="signUpButton">
              <ArrowRightIcon fill="#ffffff" width="34px" height="34px" />
            </button>

            <Link to="/sign-in" className="registerLink">
              Sign In Instead
            </Link>
          </div>
          <OAuth />
        </form>
      </div>
    </>
  )
}

export default AddAgent
